<template>
  <div class="base">
    <div class="agreementpreview">
      <div class="title">
        {{ info.title }}
      </div>
      <div class="time-area">
        <span class="time">{{ info.create_time | dayFormat }}</span>
      </div>
      <div class="content" v-html="info.content" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'ArticleList',
  props: {
    id: {}
  },
  data() {
    return {
      loading: true,
      info: {}
    }
  },
  created() {
    if (this.id === undefined) {
      this.$router.go(-1)
    }
    this.loadData(this.id)
  },
  methods: {
    loadData(id) {
      // 加载数据
      this.loading = true
      this.$http({
        url: '/index/article/info',
        method: 'get',
        params: {
          id: id
        }
      }).then(res => {
        if (res.status === 'success') {
          this.loading = false
          const data = res.data
          this.info = data.info
          console.log(data)
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    background-color: #fff;
  }

  .agreementpreview {
    display: block;
    width: 100%;
    max-width: $container-width;
    padding: 20px 10px;
    margin: auto;

    .title {
      margin-top: 10px;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
    }

    .time-area {
      margin-top: 26px;
      overflow hidden

      .time {
        font-weight: bold;
        font-size: 16px;
        float: right;
        margin-right: 40px;
      }
    }

    .content {
      text-align: left;
      margin-top: 26px;
      padding: 10px;
    }
  }

</style>
